/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.rpc.ViewServiceRpc
 */

/**
 *  Use the FilterMapper util class for mapping it to and from the CrmSearch Filter
 */

export const searchCrmObjectIdsRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjectIds',
  auth: 'app',
  fingerprint: 'yflHfy_beMCAxVV_QbHNoq8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchCrmObjectsRpc = {
  serviceName: 'com.hubspot.sales.rpc.ViewServiceRpc',
  rpcName: 'searchCrmObjects',
  auth: 'app',
  fingerprint: 'QnRUnrkSBVnpOd6Y66VOUq8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};